import IBusinessHours, { IWeekly } from '@/types/BusinessHours';

interface IGenerateScheduleArgs {
	userInput: string;
	businessHours: IBusinessHours;
}

export async function generateSchedule(args: IGenerateScheduleArgs): Promise<IWeekly> {
	let weekly: string | undefined;
	try {
		const instruction = generateInstruction(args.userInput);
		const response = (await createEdit(JSON.stringify(args.businessHours.weekly, null, 2), instruction)) as any;
		weekly = response.choices?.at(0)?.text;
	} catch (err) {
		return Promise.reject('We cannot autogenerate the schedule. Try a different sentence.');
	}
	const res = JSON.parse(weekly as string) as IWeekly;
	return res;
}

function generateInstruction(userInput: string): string {
	return `/* El JSON representa la disponibilidad semanal.

	- La disponibilidad de cada día se representa usando el nombre del día en inglés en mayúsculas,
	- Dentro de cada día tenemos un array de objetos que representan los intervalos de disponibilidad con dos campos "start" y "end" en un formato hh:mm.
	- Si un día no tiene disponibilidad utiliza un array vacío, por ejemplo: "TUESDAY": [] o "SATURDAY": [].

	Esta es la especificación en typescript:

	interface IWeekly {
		"SUNDAY": IBusinessHour[];
		"MONDAY": IBusinessHour[];
		"TUESDAY": IBusinessHour[];
		"WEDNESDAY": IBusinessHour[];
		"THURSDAY": IBusinessHour[];
		"FRIDAY": IBusinessHour[];
		"SATURDAY": IBusinessHour[];
	}

	interface IBusinessHour {
		"start": string;
		"end": string;
	}

	Para esta disponibilidad

	"${userInput}"

	Este es el objeto JSON sin comentarios:
	*/
`;
}

function createEdit(input: string, instruction: string) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + import.meta.env.VITE_OPENAI_API_KEY,
		},
		body: JSON.stringify({
			model: 'text-davinci-003',
			prompt: instruction,
			temperature: 0,
			max_tokens: 500,
			top_p: 1,
			frequency_penalty: 0,
			presence_penalty: 0,
		}),
	};

	return fetch('https://api.openai.com/v1/completions', requestOptions)
		.then((response) => response.json())
		.catch((error) => console.error(error));
}
